import React, {useEffect, useRef, useState} from 'react';
import Modal from '@result/result-ui-components/src/components/Modal';
import { useTranslation } from 'react-i18next';
import useBlocker from '../../hooks/router/useBlocker';
import handleOnUnloadEvent from '../../hooks/router/handleOnUnloadEvent';
import PropTypes from 'prop-types';
import {useNavigate} from "react-router-dom";

const FormContainer = (props) => {
	const { t } = useTranslation();
	const [showConfirmDialog, setShowConfirmDialog] = useState(false);
	const [nextLocation, setNextLocation] = useState(null);
	const navigate = useNavigate();
	const leavePageClicked = useRef(false);

	useEffect(() => {
		window.addEventListener('beforeunload', handleOnUnloadEvent);

		return () =>
			window.removeEventListener('beforeunload', handleOnUnloadEvent);
	}, []);

	const stayOnPage = () => {
		setShowConfirmDialog(false);
	};

	const leavePage = () => {
		window.removeEventListener('beforeunload', handleOnUnloadEvent);
		setShowConfirmDialog(false);
		leavePageClicked.current = true;
		navigate(nextLocation);
	};

	useBlocker((redirect) => {
		setNextLocation(redirect.pathname);
		setShowConfirmDialog(true);
	}, props.isEdited(), leavePageClicked);

	return (
		<div>
			<form onSubmit={props.onSubmit}>{props.children}</form>
			<Modal
				title={t('leave_page_title')}
				content={t('leave_page_question')}
				showPopup={showConfirmDialog}
				label={t('leave')}
				onClose={() => stayOnPage()}
				onDelete={() => leavePage()}></Modal>
		</div>
	);
};

FormContainer.propTypes = {
	isEdited: PropTypes.func,
	onSubmit: PropTypes.func,
};

export default FormContainer;